import { Component } from '@angular/core';

@Component({
  selector: 'app-linkedin-icon',
  templateUrl: 'linkedin-icon.component.svg',
  standalone: true,
})
export class LinkedinIconComponent {
}

